import {
  Grid,
  withStyles,
  WithStyles,
  createStyles,
  Theme,
} from "@material-ui/core";
import classNames from "classnames";
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import React, { Component } from "react";
import { scrollIntoView } from "../../../utils";
import { StepStatus } from "../../common/types/Stepper";

const styles = (theme: Theme) =>
  createStyles({
    childContainer: {
      fontWeight: 400,
      fontSize: "16px",
      paddingLeft: "10px",
    },
    clickable: {
      cursor: "pointer",
    },
    primaryColor: {
      backgroundColor: theme.palette.primary.main,
    },
    icon: {
      color: theme.palette.primary.contrastText,
      borderRadius: 15,
      padding: "3px",
      margin: '5px',
      fontSize: '25px'
    },
  });

interface Props extends WithStyles<typeof styles> {
  value: any;
  validate: (value: any) => boolean;
  initialStatusRenderer?: (value?: any) => React.ReactNode;
  onValidation?: (isValid: boolean) => void;
  sectionId?: string;
  isCurrentlyEditing?: boolean;
}

class SectionInContentItem extends Component<Props> {
  shouldComponentUpdate(prevProps: Props) {
    // value should be referentially different
    
    if (prevProps.value !== this.props.value || prevProps.isCurrentlyEditing !== this.props.isCurrentlyEditing) {
      return true;
    }
    return false;
  }

  renderStatusIcon = (status: StepStatus) => {
    const { initialStatusRenderer, value, isCurrentlyEditing, classes } = this.props;
    if(isCurrentlyEditing) {
      return (<EditOutlinedIcon className={`${classes.icon} ${classes.primaryColor}`} />)
    }

    let path = "";
    switch (status) {
      case StepStatus.PENDING: {
        if (initialStatusRenderer) {
          return initialStatusRenderer(value);
        } else {
          path = "/assets/svg/contentRequest/step-pending.svg";
        }
        break;
      }
      default:
        path = "/assets/svg/contentRequest/step-done.svg";
        break;
    }
    return <img src={path} alt={status} width="28px" height="28px" />;
  };

  handleClick = () => {
    const { sectionId } = this.props;
    if (sectionId) {
      scrollIntoView(sectionId);
    }
  };

  render() {
    const { classes, validate, value, onValidation, sectionId } = this.props;
    const isValid = validate(value);

    if (onValidation) {
      onValidation(isValid);
    }
    const status = isValid ? StepStatus.DONE : StepStatus.PENDING;

    return (
      <Grid
        container
        alignItems="center"
        className={classNames(sectionId && classes.clickable)}
        onClick={this.handleClick}
      >
        <Grid item xs="auto">
          {this.renderStatusIcon(status)}
        </Grid>
        <Grid item xs className={classes.childContainer}>
          {this.props.children}
        </Grid>
      </Grid>
    );
  }
}

// @ts-ignore
export default withStyles(styles)(SectionInContentItem);
